import { Link } from "react-router-dom";
import { PageHero } from "./ContentPage";
import { ServicesBento } from "../components/home/SectionsA";
import { Certified, Process, UploadCta } from "../components/home/SectionsB";
import { useSeo } from "../lib/seo";
import { useLang } from "../lib/lang";

export default function ServicesOverview({ doc, alternates }) {
  const { t } = useLang();
  useSeo({ title: doc.meta_title || `${t.nav.services} – Translinked`, description: doc.meta_description || t.services.intro, path: doc.path, lang: doc.lang, alternates });
  return (
    <main data-testid="services-page">
      <PageHero eyebrow={t.nav.services} title={t.services.title} lede={t.services.intro} />
      <div className="-mt-24"><ServicesBento /></div>
      <Certified />
      <Process />
      <UploadCta />
      <p className="sr-only"><Link to="/">Translinked</Link></p>
    </main>
  );
}
